<template functional>
    <div class="font-italic">&middot;
        {{props.cartProduct.product.type|appTranslate('name')}} #
        {{props.cartProduct.product.gender|appTranslate('name')}} #
        {{props.cartProduct.product.rannge|appTranslate('name')}}
    </div>
</template>

<script>
  export default {
    name: "cartProductTitle",
    props: {
      cartProduct: {
        type: Object,
        required: true
      }
    }
  }
</script>
